import {
  Box,
  makeStyles,
  Paper,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Typography,
  useMediaQuery,
  useTheme,
  withStyles,
} from '@material-ui/core';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import CreateIcon from '@material-ui/icons/Create';
import DescriptionIcon from '@material-ui/icons/Description';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import clsx from 'clsx';
import React from 'react';
import PageHeader from '../Common/PageHeader';

const ColorlibConnector = withStyles(({ palette }) => ({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 185deg, ' +
        palette.steicolors.lightside +
        ' 0%, ' +
        palette.steicolors.midside +
        ' 50%, ' +
        palette.steicolors.darkside +
        ' 100%)',
    },
  },
  completed: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 185deg, ' +
        palette.steicolors.lightside +
        ' 0%, ' +
        palette.steicolors.midside +
        ' 50%, ' +
        palette.steicolors.darkside +
        ' 100%)',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
}))(StepConnector);

const ColorlibConnectorVertical = withStyles(({ palette }) => ({
  alternativeLabel: {
    paddingRight: 22,
  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 185deg, ' +
        palette.steicolors.lightside +
        ' 0%, ' +
        palette.steicolors.midside +
        ' 50%, ' +
        palette.steicolors.darkside +
        ' 100%)',
    },
  },
  completed: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 185deg, ' +
        palette.steicolors.lightside +
        ' 0%, ' +
        palette.steicolors.midside +
        ' 50%, ' +
        palette.steicolors.darkside +
        ' 100%)',
    },
  },
  line: {
    width: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
    marginLeft: 12,
    marginBottom: -9,
  },
}))(StepConnector);

const useColorlibStepIconStyles = makeStyles(({ palette }) => ({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    backgroundImage:
      'linear-gradient( 224deg, ' +
      palette.steicolors.lightside +
      ' 0%, ' +
      palette.steicolors.midside +
      ' 50%, ' +
      palette.steicolors.darkside +
      ' 100%)',
  },
  completed: {
    backgroundImage:
      'linear-gradient( 224deg, ' +
      palette.steicolors.lightside +
      ' 0%, ' +
      palette.steicolors.midside +
      ' 50%, ' +
      palette.steicolors.darkside +
      ' 100%)',
  },
}));

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <CreateIcon />,
    2: <HourglassEmptyIcon />,
    3: <FindInPageIcon />,
    4: <DescriptionIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(5),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5),
      padding: theme.spacing(2),
    },
  },
  pageContent: {
    margin: theme.spacing(5),
    padding: theme.spacing(3),
  },
}));

function getSteps() {
  return [
    'Pengisian Form Pelayanan',
    'Verifikasi Identitas oleh Admin',
    'Proses Pembuatan Dokumen',
    'Dokumen Siap',
  ];
}

export function DisplayStatus(props) {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const steps = getSteps();

  const { ticketStatus } = props;

  let status = '';
  if (ticketStatus === 1) {
    status =
      'Tiket Anda masih diverifikasi identitasnya oleh Admin atau salah satu isian formulir Anda mungkin dianggap tidak valid. Apabila diperlukan, silakan perbarui dan perbaiki formulir Anda di bawah ini. ';
  } else if (ticketStatus === 2) {
    status = 'Tiket Anda sedang diproses. Harap ditunggu. ';
  } else if (ticketStatus === 3) {
    status =
      'Tiket Layanan Anda sudah selesai, silakan unduh file-nya di bawah. Apabila ingin melakukan perubahan atau memulai layanan baru, silakan buat Tiket baru.';
  } else {
    status =
      'Mohon maaf, permohonan Anda sepertinya dibatalkan atau ditolak. Harap mendaftar dengan Tiket yang baru dan pastikan identitas Anda benar.';
  }

  return (
    <>
      <PageHeader
        icon={
          <ConfirmationNumberIcon
            color={theme.palette.type === 'dark' ? 'secondary' : 'primary'}
          />
        }
        title="Status Tiket"
        subTitle="Silakan lihat status Tiket pelayanan Anda di bawah ini"
        className={classes.pageContent}
      />
      <Paper elevation={1} square className={classes.root}>
        <Box
          style={{
            alignContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Stepper
            alternativeLabel={matches ? true : false}
            activeStep={
              ticketStatus <= 3 && ticketStatus > 0 ? ticketStatus : -1
            }
            connector={
              matches ? <ColorlibConnector /> : <ColorlibConnectorVertical />
            }
            orientation={matches ? 'horizontal' : 'vertical'}
          >
            {steps.map((label, i) => (
              <Step key={label + i}>
                <StepLabel StepIconComponent={ColorlibStepIcon}>
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        <Typography variant="subtitle2" color="textSecondary" align="center">
          {status}
        </Typography>
      </Paper>
    </>
  );
}
